import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="resumin--home-tab"
// ホームページ専用のタブコントローラー（新規作成セクション制御機能付き）
export default class extends Controller {
  static targets = ["tab", "tabBody", "newCreateSection"];
  static values = {
    isLogin: Boolean,
    hasEntrySheet: Boolean,
    hasSkillSheet: Boolean,
  };

  connect() {
    // 初期状態で新規作成セクションの表示を制御
    // 現在アクティブなタブを取得（ビューで設定された状態を反映）
    const activeTabBody = this.tabBodyTargets.find((target) =>
      target.classList.contains("block")
    );
    const activeTab = activeTabBody
      ? activeTabBody.dataset["resumin-HomeTabContentValue"]
      : "entry-sheet";
    this.updateNewCreateSectionVisibility(activeTab);
  }

  toggle(e) {
    const value = e.currentTarget.dataset["resumin-HomeTabTargetContentValue"];

    // すべてのタブボタンから is-active を削除し、ARIA属性を更新
    this.tabTargets.forEach((target) => {
      target.classList.remove("is-active");
      target.setAttribute("aria-selected", "false");
      target.setAttribute("tabindex", "-1");
    });

    // すべてのタブコンテンツを非表示にする
    this.tabBodyTargets.forEach((target) => {
      target.classList.replace("block", "hidden");
    });

    // 対象のタブコンテンツを表示
    const targetBody = this.tabBodyTargets.find(
      (target) => target.dataset["resumin-HomeTabContentValue"] === value
    );
    if (targetBody) {
      targetBody.classList.replace("hidden", "block");

      // 表示されたセクション内のタブボタンに is-active を追加し、ARIA属性を更新
      const activeTabButton = targetBody.querySelector(
        `[data-resumin--home-tab-target-content-value="${value}"]`
      );
      if (activeTabButton) {
        activeTabButton.classList.add("is-active");
        activeTabButton.setAttribute("aria-selected", "true");
        activeTabButton.setAttribute("tabindex", "0");
      } else {
        // 既存の動作：クリックされたボタンに is-active を追加
        e.currentTarget.classList.add("is-active");
        e.currentTarget.setAttribute("aria-selected", "true");
        e.currentTarget.setAttribute("tabindex", "0");
      }

      // 新規作成セクションの表示制御
      this.updateNewCreateSectionVisibility(value);

      // ヒーローセクションの画像とボタンを更新
      this.updateHeroSection(value);

      // セッションにアクティブなタブを保存（サーバーにリクエストを送信）
      this.saveActiveTabToSession(value);
    }
  }

  updateHeroSection(activeTab) {
    // ヒーローセクションはコントローラーのスコープ外にあるため、document.querySelectorで取得
    const heroButtons = document.querySelector(
      '[data-resumin--home-tab-target="heroButtons"]'
    );
    const heroImage = document.querySelector(
      '[data-resumin--home-tab-target="heroImage"]'
    );

    if (heroButtons && heroImage) {
      // data属性から値を取得
      const entrySheetExists =
        heroButtons.dataset["resumin-HomeTabEntrySheetExistsValue"] === "true";
      const skillSheetExists =
        heroButtons.dataset["resumin-HomeTabSkillSheetExistsValue"] === "true";
      const isLogin =
        heroButtons.dataset["resumin-HomeTabIsLoginValue"] === "true";
      const pcImage = heroButtons.dataset["resumin-HomeTabPcImageValue"];
      const pc02Image = heroButtons.dataset["resumin-HomeTabPc02ImageValue"];

      // アクティブなタブに対応するシートの有無を判定
      const activeSheetExists =
        activeTab === "entry-sheet" ? entrySheetExists : skillSheetExists;

      // 画像のsrcsetを更新
      const newImagePath = isLogin && activeSheetExists ? pc02Image : pcImage;
      heroImage.setAttribute("srcset", newImagePath);

      // ボタンの表示/非表示を切り替え
      if (activeSheetExists) {
        heroButtons.style.display = "none";
      } else {
        heroButtons.style.display = "";
      }
    }
  }

  saveActiveTabToSession(activeTab) {
    // CSRFトークンを安全に取得
    const csrfToken = document.querySelector('meta[name="csrf-token"]');
    if (!csrfToken) {
      console.error("CSRF token not found");
      return;
    }

    // サーバーにアクティブなタブを保存するためのリクエストを送信
    fetch("/home/save_active_tab", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken.content,
        Accept: "application/json",
      },
      body: JSON.stringify({ active_tab: activeTab }),
    }).catch((error) => {
      console.error("Failed to save active tab:", error);
    });
  }

  updateNewCreateSectionVisibility(activeTab) {
    let shouldShow = false;

    // 未ログイン時のみ制御
    if (!this.isLoginValue) {
      // 未ログインの場合、選択されたタブに対応するデータがある場合のみ表示
      if (activeTab === "entry-sheet" && this.hasEntrySheetValue) {
        shouldShow = true;
      } else if (activeTab === "skill-sheet" && this.hasSkillSheetValue) {
        shouldShow = true;
      }
    } else {
      // ログイン済みの場合は制御不要
      return;
    }

    // カスタムイベントを発火して、範囲外のnewCreateSectionに通知
    const event = new CustomEvent("newCreateSectionToggle", {
      detail: { shouldShow: shouldShow, activeTab: activeTab },
    });
    document.dispatchEvent(event);
  }
}
